// extracted by mini-css-extract-plugin
module.exports = {"label":"Input_label__2hv4_","input":"Input_input__PcRaj"};